// @ts-nocheck
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Stack, Group, Center } from '@/components/ui/layout';
import { Title, Text, Button, Anchor } from '@/components/ui/core';
import { TextInput, PasswordInput, Checkbox } from '@/components/ui/inputs';
import { IconUser, IconMail, IconLock, IconArrowLeft, IconCheck, IconCloud, IconDevices, IconHeadset } from '@tabler/icons-react';
import { AuthLayoutWrapper, SocialLoginButtons, PasswordStrength } from '../components';

export default function RegisterSplit() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [acceptTerms, setAcceptTerms] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Register attempt:', { name, email, password });
  };

  const features = [
    { icon: IconCloud, title: 'Cloud Storage', desc: 'Secure file storage up to 100GB' },
    { icon: IconDevices, title: 'Multi-Device', desc: 'Access from anywhere, anytime' },
    { icon: IconHeadset, title: '24/7 Support', desc: 'We\'re here to help you' },
  ];

  const splitContent = (
    <Stack gap="xl" p="xl" style={{ color: 'white' }}>
      <div>
        <Title order={1} c="white" mb="md">Start your free trial</Title>
        <Text size="lg" style={{ opacity: 0.9 }}>
          No credit card required. Get started in minutes.
        </Text>
      </div>

      <Stack gap="lg" mt="xl">
        {features.map((feature) => (
          <Group key={feature.title} gap="md">
            <Center
              style={{
                width: 48,
                height: 48,
                borderRadius: 12,
                backgroundColor: 'rgba(255,255,255,0.15)',
              }}
            >
              <feature.icon size={24} />
            </Center>
            <div>
              <Text fw={600}>{feature.title}</Text>
              <Text size="sm" style={{ opacity: 0.8 }}>{feature.desc}</Text>
            </div>
          </Group>
        ))}
      </Stack>

      <Stack gap="xs" mt="xl">
        {['14-day free trial', 'No credit card required', 'Cancel anytime'].map((item) => (
          <Group key={item} gap="xs">
            <IconCheck size={16} style={{ opacity: 0.8 }} />
            <Text size="sm" style={{ opacity: 0.9 }}>{item}</Text>
          </Group>
        ))}
      </Stack>
    </Stack>
  );

  return (
    <AuthLayoutWrapper
      variant="split"
      splitContent={splitContent}
      gradientFrom="#0ea5e9"
      gradientTo="#6366f1"
      backgroundImage="https://images.unsplash.com/photo-1557683311-eac922347aa1?w=1200&auto=format&fit=crop"
    >
      <Stack gap="lg">
        {/* Back button */}
        <Button
          component={Link}
          to="/app/demo/auth-pages/register"
          variant="subtle"
          size="xs"
          leftSection={<IconArrowLeft size={14} />}
          w="fit-content"
        >
          Back to variants
        </Button>

        {/* Header */}
        <div>
          <Title order={2}>Create your account</Title>
          <Text c="dimmed" size="sm" mt="xs">
            Fill in the details below to get started
          </Text>
        </div>

        {/* Social Login First */}
        <SocialLoginButtons
          providers={['google', 'github']}
          layout="horizontal"
          showDivider={false}
        />

        <Group gap="xs" justify="center">
          <div style={{ flex: 1, height: 1, backgroundColor: 'var(--mantine-color-gray-3)' }} />
          <Text size="xs" c="dimmed">or register with email</Text>
          <div style={{ flex: 1, height: 1, backgroundColor: 'var(--mantine-color-gray-3)' }} />
        </Group>

        {/* Form */}
        <form onSubmit={handleSubmit}>
          <Stack gap="md">
            <TextInput
              label="Full name"
              placeholder="John Doe"
              leftSection={<IconUser size={16} />}
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
            />

            <TextInput
              label="Work email"
              placeholder="john@company.com"
              leftSection={<IconMail size={16} />}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />

            <div>
              <PasswordInput
                label="Password"
                placeholder="Min 8 characters"
                leftSection={<IconLock size={16} />}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
              {password && <PasswordStrength password={password} variant="steps" />}
            </div>

            <Checkbox
              label={
                <Text size="sm">
                  I agree to the <Anchor size="sm">Terms</Anchor> and{' '}
                  <Anchor size="sm">Privacy Policy</Anchor>
                </Text>
              }
              checked={acceptTerms}
              onChange={(e) => setAcceptTerms(e.currentTarget.checked)}
            />

            <Button type="submit" fullWidth color="cyan">
              Create free account
            </Button>
          </Stack>
        </form>

        {/* Login Link */}
        <Text ta="center" size="sm">
          Already have an account?{' '}
          <Anchor component={Link} to="/app/demo/auth-pages/login/split" fw={500}>
            Sign in
          </Anchor>
        </Text>
      </Stack>
    </AuthLayoutWrapper>
  );
}
